module.exports = __webpack_public_path__ + "img/turgot.f8a0f843.jpg";